import { NavigationOptionEnum } from './workflow.type';
import { DummyRole } from './workflow.v2.type';

export type RoleNavigationConfigType = {
  pageId?: string | undefined;
  selectedZone: string | undefined;
  selectedRole: string | undefined;
  selectedPageIndex: number | undefined;
  selectedPageUrl: string | undefined;
  selectedPageId: string | undefined;
  tabRef?: string | undefined;
  selectedBrowserBehaviour?: string;
  externalUrl?: string;
  selectedNavigationOption: string;
  pageTransition?: string | undefined;
};

export enum ActionButtonOutcomesType {
  SUCCESS = 'success',
  FAILURE = 'failure',
  PROCESSING = 'processing',
  INCOMPLETE = 'incomplete',
  ALTERNATE_1 = 'alternate_1',
  ALTERNATE_2 = 'alternate_2',
  ALTERNATE_3 = 'alternate_3',
  PRODUCT_UNAVAILABLE = 'product_unavailable',
}

export type actionButtonNavigationConfigType = {
  [key in ActionButtonOutcomesType]?: RoleNavigationConfigType;
};

export type actionButtonOutcomeLabelsConfigType = { outcomeType: ActionButtonOutcomesType; label: string };

export const defaultNavigationConfig = {
  selectedZone: '',
  selectedRole: DummyRole.EMPTY_ROLE,
  selectedPageIndex: 0,
  selectedPageUrl: '',
  selectedPageId: '',
  tabRef: '',
  selectedBrowserBehaviour: '',
  externalUrl: '',
  selectedNavigationOption: NavigationOptionEnum.USE_AS_NAVIGATION,
  pageTransition: 'forward',
};
